import React from 'react';
import { IoIosArrowRoundForward } from "react-icons/io";
const arrow =  {fontSize: '2em' };

const SignUp = () => {
  return (
    <div className='SignUp'>
        <div className='signUp'>
                        Sign up
                        </div>  
                        <div className='ex-signUp'>
                            Sign up for special deals and keep up to date with all things Marshmallow Moon.
                            < br />
                            <small>we will not spam you or sell your info </small>
                            🤞
                        </div>
                        <div className="form-control d-flex">
                        <label value="input">
                    <input type='text' class="form-control" id="signUp" placeholder="email address"  />
                    
                        <span className='arrow-sign btn' type='submit'   >
                         <IoIosArrowRoundForward  style={arrow}/>
                         </span></label>
                    </div> 
                    </div>
  )
}

export default SignUp

